import { render, staticRenderFns } from "./Modelo2Component.vue?vue&type=template&id=73d994e4"
import script from "./Modelo2Component.vue?vue&type=script&lang=js"
export * from "./Modelo2Component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports